import { BrowserModule } from '@angular/platform-browser';
import { CUSTOM_ELEMENTS_SCHEMA, ErrorHandler, NgModule } from '@angular/core';
import { AppRouterModule } from './app-routing.module';
import { AppComponent } from './app.component';
import { RouterModule } from '@angular/router';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { OverlayModule } from '@angular/cdk/overlay'
import { ColorPickerService } from 'ngx-color-picker';
import { AuthenticationComponent } from './authentication/authentication.component';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { ToastrModule } from 'ngx-toastr';
import { HTTP_INTERCEPTORS, provideHttpClient, withInterceptorsFromDi } from  '@angular/common/http';
import { NgSelectModule } from '@ng-select/ng-select';
import { PagesComponent } from './pages/pages.component';
import { SharedModule } from './shared/shared.module';
import { NgxDatatableModule } from '@swimlane/ngx-datatable';
import { NgbModule } from '@ng-bootstrap/ng-bootstrap';
import { PagesModule } from './pages/pages.module';
import { SessionExpiredInterceptor } from './interceptors/session-expired.interceptor';
import { BearerAuthInterceptor } from './interceptors/bearer-auth.interceptor';
import { GlobalHttpErrorInterceptor } from './interceptors/global-http-error.interceptor';
import { FrontendGlobalErrorHandler } from './core/errors/frontend-global-error.handler';

@NgModule({ declarations: [
        PagesComponent,
        AppComponent,
        AuthenticationComponent,
    ],
    exports: [],
    bootstrap: [AppComponent],
    schemas: [CUSTOM_ELEMENTS_SCHEMA], imports: [AppRouterModule,
        BrowserModule,
        BrowserAnimationsModule,
        FormsModule,
        PagesModule,
        ReactiveFormsModule,
        RouterModule,
        OverlayModule,
        NgSelectModule,
        SharedModule,
        ToastrModule.forRoot(),
        NgxDatatableModule,
        NgbModule], providers: [
        ColorPickerService,
        {
            provide: HTTP_INTERCEPTORS,
            useClass: BearerAuthInterceptor,
            multi: true
        },
        {
            provide: HTTP_INTERCEPTORS,
            useClass: SessionExpiredInterceptor,
            multi: true
        },
        {
            provide: HTTP_INTERCEPTORS,
            useClass: GlobalHttpErrorInterceptor,
            multi: true
        },
        {
            provide: ErrorHandler,
            useClass: FrontendGlobalErrorHandler
        },
        provideHttpClient(withInterceptorsFromDi())
    ] })
export class AppModule { }
